<div id="module-cards-list" [@animateStagger]="{ value: '50' }" [class.fixed-width-tiles]="fixedWidthTiles">
    <span id="ruler" class="ruler"></span>
    <div
        class="modules-card-container"
        [fxLayout]="fixedWidthTiles ? null : 'row wrap'"
        [fxLayoutAlign]="fixedWidthTiles ? null : 'start'"
    >
        <div
            class="module-card image-module-card"
            [class.p-4]="!fixedWidthTiles"
            *ngFor="let module of myModule$ | async"
            [@animate]="{ value: '*', params: { y: '100%' } }"
        >
            <app-modules-card
                (clickedTag)="tagMultiSelectService.tagSelected($event, 'myModulesSelectedTags')"
                (clickedPinModule)="onPinModule($event)"
                [module]="module"
                [finalGrade]="finalGrades[module.id]"
                [myModuleUser]="myModuleUser[module.id]"
                [profile]="profile"
                [isCertificateOfAttendanceFeatureEnabled]="isCertificateOfAttendanceFeatureEnabled"
                [isPinned]="isPinned"
                [showPinModule]="showPinModule"
                [isTeamMembersPage]="isTeamMembersPage"
            ></app-modules-card>
        </div>
    </div>
</div>
